import React, { useRef, useState } from 'react';
import StarsImage from '../../assets/Images/stars_hair_design.png';
import useSpringPhoto from './useSpringPhoto';
import './Story.scss';

const Story = ({t}) => {
	const [hovered, setHovered] = useState(false);
	const toggleHover = () => setHovered(prev => !prev);
	const paragraphRef = useRef(null);

	const { imageRef } = useSpringPhoto({
		active: hovered,
		paragraphRef,
		onDeactivate: () => setHovered(false)
	});

	return (
		<>
			<section className="story" id="story">
			<div className="image_container">
					<img
					ref={imageRef}
					alt="star's hair design shop"
						className={hovered ? "stars_shop is-active" : "stars_shop"} src={StarsImage}
					/>
				</div>
				<h3>{t('Story.1')}</h3>
				<p ref={paragraphRef} onMouseEnter={toggleHover} onMouseLeave={toggleHover}>{t('Story.2')}</p>
			</section>
		</>
	)
}

export default Story
